import { Component, OnInit } from '@angular/core';
import { FashionLoginComponent } from 'gung-standard';

@Component({
    selector: 'cult-cult-login',
    templateUrl: './cult-login.component.html',
    styleUrls: ['./cult-login.component.scss'],
    standalone: false
})
export class CultLoginComponent extends FashionLoginComponent implements OnInit {
  ngOnInit(): void {
    super.ngOnInit();
  }
}
